import axios from "axios";
import { BASE_URL } from "../utils/apiConstant";
import store from "../redux/store";
import ACTION_TYPES from "../redux/types";


const clearAllCookies = () => {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if(name==='user') document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
    }
}

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    timeout: 30000,
})

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        console.log("Unauthorized — logging out");
  
        store.dispatch({
          type: ACTION_TYPES.GET_USER,
          payload: null,
        });
  
        sessionStorage.clear();
  
      }
  
      return Promise.reject(error);
    }
  );

const errorHandleing = async(error) => {
    if (error.response && error.response.status === 401) {
        console.log("Unauthorized access")

        store.dispatch({
            type: ACTION_TYPES.GET_USER,
            payload: null,
          });
        clearAllCookies();
        sessionStorage.clear();
         window.location.href = "/login";
    }
    return Promise.reject(error);
};

const reqHandeling = async (config) => {
    const obj = {...config};

    return obj;
}

const resHandeling = (response) => response;

axiosInstance.interceptors.request.use(reqHandeling, errorHandleing);
//axiosInstance.interceptors.response.use(resHandeling, errorHandleing);

export default axiosInstance;